import { Call, Partner, PartnerListSummary } from '../models';
import { ModelResource } from './resource';

interface CreateCallData {
  invoices: string[];
  phone_number?: string;
}

export class Calls extends ModelResource<Call, CreateCallData> {
  model = Call;

  resourcePath = 'v1/calls';

  async bulkCall(partners: (Partner | PartnerListSummary)[]) {
    return this.api.post(this.path('bulk'), {
      data: {
        partners: partners.map((partner) => partner.id),
      },
    });
  }
}
